/**
 * Ошибка, о которой не нужно оповещать пользователя.
 * Это обычная Error, но пользователю не покажется toast при её выбрасывании.
 */
export class UnannouncedError extends Error {
  constructor(message: string) {
    super(message)
    this.name = 'UnannouncedError'
  }
}
